<template>
  <div :id="id" class="modal fade" role="dialog">
    <div :class="['modal-dialog', `modal-${size}`]">
      <div class="modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    id: {
      default: 'myModal',
      type: String,
      required: true
    },
    size: {
      default: 'lg',
      type: String,
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Modal/Modal.vue